/* ======================================================================
   МОДУЛЬ DRIP-GUARD: ЗАЩИТА СТРАНИЦ, ДИПЛИНКИ И КАПЕЛЬНЫЙ ДОСТУП
   ====================================================================== */

function handleDeeplinksAndHash(currentPath) {
  const isDashboardPage = currentPath.endsWith('dashboard.html') || currentPath.endsWith('dashboard');

  // 1. Диплинки по хешу (#referral, #dashboard, #questionnaire, #quest)
  if (window.location.hash) {
    const h = window.location.hash.toLowerCase();
    if (h === '#referral' || h.startsWith('#referral')) {
      if (!currentPath.includes('referral.html')) {
        spaNavigate('/referral.html' + (window.location.search || ''), false);
        return true;
      }
    } else if (h === '#dashboard' || h.startsWith('#dashboard')) {
      if (!isDashboardPage) {
        spaNavigate('/dashboard.html' + (window.location.search || ''), false);
        return true;
      }
    } else if (h === '#questionnaire' || h === '#quest' || h.startsWith('#quest')) {
      if (!currentPath.includes('questionnaire.html')) {
        spaNavigate('/questionnaire.html' + (window.location.search || ''), false);
        return true;
      }
    }
  }

  // 2. Диплинки в Telegram WebApp (?startapp=quest)
  const tgStartParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
  const urlParamsObj = new URLSearchParams(window.location.search);
  const startVal = (tgStartParam || urlParamsObj.get('startapp') || urlParamsObj.get('start') || '').toLowerCase();
  if (startVal === 'quest' || startVal === 'questionnaire' || startVal === 'anketa') {
    if (!currentPath.includes('questionnaire.html')) {
      spaNavigate('/questionnaire.html' + (window.location.search || ''), false);
      return true;
    }
  }

  return false;
}

function handleNavigationGuard(currentPath, syncPromise) {
  const isDashboardPage = currentPath.endsWith('dashboard.html') || currentPath.endsWith('dashboard');
  const isProtectedDayPage = currentPath.includes('day-1') || currentPath.includes('day-2') || currentPath.includes('day-3') || currentPath.includes('day-4');
  const isProtectedPage = isDashboardPage || isProtectedDayPage || currentPath.includes('referral') || currentPath.includes('questionnaire') || currentPath.includes('course-tariffs');

  if (isRegistered()) {
    document.documentElement.classList.remove('meta-auth-checking');
    const user = getUser();
    if (isDashboardPage) {
      updateDashboardUI(user);
      setTimeout(checkCelebration, 500);
    }
    return;
  }

  // Ожидаем фоновую синхронизацию профиля перед принятием решений об авторизации
  Promise.resolve(syncPromise).then(() => {
    document.documentElement.classList.remove('meta-auth-checking');
    if (isRegistered()) {
      if (isDashboardPage) {
        updateDashboardUI(getUser());
        setTimeout(checkCelebration, 500);
      }
    } else if (isDashboardPage) {
      // На странице личного кабинета не выталкиваем пользователя на главную,
      // а открываем форму регистрации прямо поверх кабинета
      checkAndTriggerAutoRegister(true);
    } else if (isProtectedPage) {
      // Для защищенных страниц уроков открываем модалку на месте
      if (typeof openModal === 'function') {
        openModal(currentPath);
      } else {
        checkAndTriggerAutoRegister(true);
      }
    } else {
      checkAndTriggerAutoRegister();
    }
  }).catch(() => {
    document.documentElement.classList.remove('meta-auth-checking');
    if (isRegistered()) {
      if (isDashboardPage) {
        updateDashboardUI(getUser());
        setTimeout(checkCelebration, 500);
      }
    } else if (isDashboardPage) {
      checkAndTriggerAutoRegister(true);
    } else if (isProtectedPage) {
      if (typeof openModal === 'function') {
        openModal(currentPath);
      } else {
        checkAndTriggerAutoRegister(true);
      }
    } else {
      checkAndTriggerAutoRegister();
    }
  });

  // Перехватываем все ссылки входа в личный кабинет и уроки
  document.querySelectorAll('a[href*="dashboard"], a[href*="day-"], a[href*="referral"], a[href*="questionnaire"], a[href*="course-tariffs"]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (!isRegistered()) {
        e.preventDefault();
        e.stopPropagation();
        const targetHref = btn.getAttribute('href') || '/dashboard.html';
        openModal(targetHref);
      }
    });
  });
}

window.handleDeeplinksAndHash = handleDeeplinksAndHash;
window.handleNavigationGuard = handleNavigationGuard;